<script setup>
</script>
<template>
    <div class="loader">
        <img  class="form-loader" width="50" height="50" src="@/assets/img/icons/loader_white.svg" alt="изображение" />
    </div>
</template>
<style lang='scss' scoped>
.loader {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: .9;
    z-index: 4;
    img {
        width: 5rem;
        height: 5rem;
        animation: loader 1s linear infinite;
    }
}
@keyframes loader {
    0% {transform: rotate(0);}
    100% {transform: rotate(360deg);}
}
</style>